import router from '@/router/index'
import axios from '@/services/axios'

export const getUser = () => {
  const json = window.localStorage.getItem('user')
  if (json) {
    return JSON.parse(json)
  }
}

export const setUser = (value) => {
  window.localStorage.setItem('user', JSON.stringify(value))
}

export const getToken = () => {
  const user = getUser()
  if (user && typeof user.token !== 'undefined') {
    return user.token
  }
}

export const isLogged = () => {
  return !!getUser()
}

export const logout = () => {
  axios.get('/logout')
  window.localStorage.setItem('user', null)
  router.push('/login')
}



// WEBPACK FOOTER //
// ./src/services/auth.js